// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import packageJson from '../../package.json';

export const environment = {
  appVersion: packageJson.version + '-dev',
  production: false,
  mapbox: {
    accessToken: 'pk.eyJ1IjoiamVhbnZpZXV4IiwiYSI6ImNqcGRoZG9mODAzbmszcmsyc25yeGZkcWcifQ.064e2CW2O3aG8UQ_6XilbQ'
  }
};

console.log('App Version: ' + environment.appVersion);
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
